import { defineComponent as _defineComponent } from 'vue'
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import TUISearch from "../TUISearch/index.vue";
import { ref } from "../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');

const handleSwitchConversation = () => {
  if (isUniFrameWork.value)
    uni.navigateTo({
    url: '/TUIKit/components/TUIChat/index',
  });
};

return { __sfc: true,isPC, isUniFrameWork, handleSwitchConversation, TUISearch }
}

})